import { Typography } from 'components';

import { useTranslations } from 'next-intl';

const HeaderTaskInProgress = () => {
  const t = useTranslations();

  return (
    <thead className="!h-12 bg-tertiary-300">
      <tr>
        <th className="w-24 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.task_id')}
          </Typography>
        </th>
        <th className="w-20 break-words pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.ready_to_review_since')}
          </Typography>
        </th>
        <th className="w-14 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.languages')}
          </Typography>
        </th>
        <th className="w-28  py-4 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.quality')}
          </Typography>
        </th>
        <th className="w-16 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.total_words')}
          </Typography>
        </th>
        <th className="w-28 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.translators')}
          </Typography>
        </th>
        <th className="ml-2 w-14 pl-4 text-left">
          <Typography variant="regular4" className="text-white">
            {t('components.tasks_languages.comments')}
          </Typography>
        </th>
        <th className="w-12 pl-4 text-left">
          <Typography variant="regular4" className="whitespace-nowrap text-white">
            {t('components.tasks_languages.translation_request_ids')}
          </Typography>
        </th>
      </tr>
    </thead>
  );
};

export default HeaderTaskInProgress;
